import { useMutation, useQueryClient } from 'react-query';

import { postV2ApiOrganisationIdSettingsMerge } from 'src/client/spendesk-api';
import { useOrganisationId } from 'src/core/modules/app/hooks/useOrganisationId';

import { type Setting } from '../setting';

type MergeEntitySpecificCostCenterData = {
  name: string;
  ownerId: string;
  viewerIds: string[];
  targetCompanyIds: string[];
  entitySpecificIds: {
    costCenterId: string;
    companyId: string;
  }[];
  crossEntitySettingsIds: Setting['id'][];
};
export const useMergeEntitySpecificCostCenter = () => {
  const organisationId = useOrganisationId();
  const queryClient = useQueryClient();

  return useMutation(
    ['settings', 'merge'],
    async (payload: MergeEntitySpecificCostCenterData): Promise<void> => {
      const response = await postV2ApiOrganisationIdSettingsMerge({
        path: {
          organisationId,
        },
        body: {
          type: 'costCenter',
          data: {
            name: payload.name,
            ownerId: payload.ownerId,
            viewerIds: payload.viewerIds,
          },
          crossEntitySettingsIds: payload.crossEntitySettingsIds,
          entitySpecificIds: payload.entitySpecificIds,
          targetCompanyIds: payload.targetCompanyIds,
        },
      });

      if (response.statusCode !== 200) {
        throw new Error('Failed to create cost center');
      }
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['settings', organisationId]);
      },
    },
  );
};
